export const navigationItems = [
  {
    title: 'My Projects',
    colTitle: '',
    icon: 'mdi-map',
    event: 'project-index',
    size: 'large'
  },
  {
    title: 'How to get started',
    colTitle: '',
    icon: 'mdi-help-circle',
    event: 'how-to-get-started',
    size: 'large'
  },
  {
    title: 'About SPIN',
    colTitle: '',
    icon: 'mdi-account-group',
    event: 'about-spin',
    size: 'large'
  },
  {
    title: 'Project Examples',
    colTitle: '',
    icon: 'mdi-briefcase-outline',
    event: 'project-examples',
    size: 'large'
  },
  {
    title: 'Contact Us',
    colTitle: '',
    icon: 'mdi-book-open-page-variant',
    event: 'contact-us',
    size: 'large'
  }
]
